import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'TurbotenantTheme',
  code: 'turbotenant',
  colors: {
    headerBackground: '#fff',
    headerText: '#212529',
    headerBorder: '#e0e7e9',
    background: '#f9f9f9',
    footerBackground: '#2370a3',
    footerText: '#fff',
    footerBorder: 'transparent',
    progressBar: '#033a6d',
  },
  logoSize: {
    width: '282px',
    height: '40px',
  },
  baseColors: {
    link: '#033a6d',
    cta: '#033a6d',
    hover: '#2370a3',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const TurbotenantTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
